module.exports = __webpack_public_path__ + "static/img/img_culture_h.c413f169.png";